import {FC} from 'react';
import clsx from 'clsx';
import Avatar from 'components/Avatar';
import Field from 'components/Form/Field';
import KeyValue from 'components/Layout/KeyValue';
import Value from 'components/Value';
import {t} from 'ttag';
import {OverviewEmployee} from '../types';

type InformationCardProps = {
    className?: string;
} & OverviewEmployee;

const InformationCard: FC<InformationCardProps> = ({
    className,
    companyName,
    createdBy,
    dateCreated,
    email,
    endDate,
    isApiEmployee,
    name,
    startDate,
}) => (
    <div
        className={clsx(
            'flex gap-4 rounded border border-grey-200 p-4',
            className,
        )}
        id="information-card"
    >
        {isApiEmployee && <Avatar size="xl" type="api" />}
        {!isApiEmployee && <Avatar size="xl" />}
        <div className="grid gap-2">
            <div className="text-lg font-semibold">{companyName}</div>
            <div className="font-semibold">{name}</div>
            {isApiEmployee && (
                <KeyValue>
                    {createdBy && (
                        <Field label={t`Created By`} type="value">
                            <Value value={{type: 'string', value: createdBy}} />
                        </Field>
                    )}
                    {dateCreated && (
                        <Field label={t`Date Created`} type="value">
                            <Value
                                value={{
                                    format: 'date',
                                    type: 'date',
                                    value: new Date(dateCreated),
                                }}
                            />
                        </Field>
                    )}
                </KeyValue>
            )}
            {!isApiEmployee && (
                <>
                    <div>{email}</div>
                    <KeyValue>
                        {startDate && (
                            <Field label={t`Start Date`} type="value">
                                <Value
                                    value={{
                                        format: 'date',
                                        type: 'date',
                                        value: new Date(startDate),
                                    }}
                                />
                            </Field>
                        )}
                        {endDate && (
                            <Field label={t`End Date`} type="value">
                                <Value
                                    value={{
                                        format: 'date',
                                        type: 'date',
                                        value: new Date(endDate),
                                    }}
                                />
                            </Field>
                        )}
                    </KeyValue>
                </>
            )}
        </div>
    </div>
);

export default InformationCard;
